export const positiveParentingTips0To9Months = {
  title: 'Consejos de crianza positiva de los hijos',
  body: [
    // 'Estas son algunas cosas que usted, como padre, puede hacer para ayudar a su bebé en esta etapa:',
    [
      'Háblele a su bebé. Su voz lo calmará.',
      'Responda cuando su bebé haga sonidos repitiendo los sonidos y agregando palabras. Esto le ayudará a aprender a usar el lenguaje.',
      'Léale. Esto lo estimulará a crear sonidos y a entender el lenguaje.',
      'Cántele y póngale música. Esto ayudará a que comience a apreciar la música y también ayudará a su desarrollo cerebral.',
      'Elogie lo que hace su bebé y dele mucho amor.',
      'Pase tiempo abrazándolo y cargándolo. Esto ayudará a que se sienta seguro y querido.',
      'Juegue con su bebé cuando esté alerta y relajado. Déjelo descansar si muestra señales de cansancio o molestia.',
      'Entretenga a su bebé con juguetes y llévelo a áreas seguras cuando comience a moverse y a tocar objetos que no debe tocar.',
      'Cuide de su salud física, mental y emocional. La crianza y educación pueden ser tareas demandantes. Si usted se siente bien consigo mismo, le será más fácil disfrutar de su bebé, y ser un padre positivo y amoroso.',
    ]
  ]
}

export const positiveParentingTips12To18Months = {
  title: 'Consejos de crianza positiva de los hijos',
  body: [
    [
      'Léale a diario.',
      'Pídale que le busque objetos, o que le nombre objetos o las partes del cuerpo.',
      'Participe con él en juegos de asociación, como en los que debe clasificar figuras por su forma y hacer rompecabezas sencillos.',
      'Anímelo a explorar y a probar cosas nuevas.',
      'Contribuya a su desarrollo del lenguaje hablando con él y completando palabras que comience a decir. Por ejemplo, si su pequeño dice “bib-e”, usted puede contestar: “Sí, eso es un biberón”.',
      'Fomente la independencia que está adquiriendo dejándolo que se vista y coma por sí solo.',
      'Reaccione más a los comportamientos positivos del niño que cuando tenga que castigarlo por comportamientos negativos (los castigos, como no dejarlo hacer nada, deben ser muy breves). En lugar de eso, dígale o muéstrele lo que debería haber hecho.',
      'Vayan juntos al parque o den un paseo en autobús para fomentar en el niño la curiosidad y su capacidad para reconocer objetos comunes.',
    ]
  ]
}

export const positiveParentingTips24To36Months = {
  title: 'Consejos de crianza positiva de los hijos',
  body: [
    [
      'Reserve una hora especial para leer libros con su hijo.',
      'Anímelo a participar en juegos de simulación.',
      'Jueguen a seguir al líder.',
      'Llévelo a pasear, ya sea caminando o jalándolo en un vagoncito, para que explore el ambiente que lo rodea.',
      'Aliéntelo a que diga su nombre y su edad.',
      'Enséñele canciones sencillas como “La araña pequeñita” u otras rimas culturales de la infancia.',
      'Préstele atención a su hijo y elogios cuando siga las instrucciones y muestre un comportamiento positivo, y limite la atención por el comportamiento desafiante, como las rabietas. Enséñele formas aceptables de demostrar que está molesto.',
    ]
  ]
}

export const positiveParentingTips48MonthsOnward = {
  title: 'Consejos de crianza positiva de los hijos',
  body: [
    [
      'Continúe leyéndole a su hijo. Llévelo a las bibliotecas y librerías para inculcarle el amor por los libros.',
      'Permítale que ayude con tareas sencillas.',
      'Anímelo a que juegue con otros niños. Esto lo ayudará a entender el valor de compartir y de la amistad.',
      'Sea claro y no cambie las reglas a la hora de disciplinar a su hijo. Explíquele y muéstrele el comportamiento que espera de él. Cuando le diga que no, dígale lo que debería hacer.',
      'Ayude a su hijo a desarrollar destrezas del lenguaje hablándole con oraciones completas y palabras de adultos. Ayúdelo a usar las palabras y frases correctas.',
      'Ayude a su hijo a resolver problemas cuando esté frustrado.',
      'Dele un número limitado de opciones sencillas (por ejemplo, que decida la ropa que se pondrá, cuándo puede jugar y qué va a comer de refrigerio).',
    ]
  ]
}

